// import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
// import * as Sentry from "@sentry/browser";
// import { isMyAppWKWebView } from "./isMyAppWKWebView";


/**
 * @returns verificationId
 */
export async function verifyNumber(phoneNumber: string) {
  if (window.Android) {
    if (!window._androidPromise) {
      window._androidPromise = {};
    }

    // if returnPromise resolves to true, it means Firebase did some magic and the user is already signed in
    const promiseId = window.crypto.randomUUID();
    const returnPromise = new Promise<string | true>((resolve, reject) => {
      // biome-ignore lint/style/noNonNullAssertion: <explanation>
      window._androidPromise![promiseId] = { resolve, reject };
    });

    window.Android.verifyNumber(promiseId, phoneNumber);

    return returnPromise;
  }

  // if (isMyAppWKWebView()) {
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  return (window.webkit as any).messageHandlers.verifyNumber.postMessage(phoneNumber);
  // }

  // return (await verifyNumberWebBridge(phoneNumber)).verificationId ?? true;
}

// async function verifyNumberWebBridge(phoneNumber: string): Promise<{ verificationId: string | null; error: string | null }> {
//     try {
//       const auth = getAuth();
//       auth.useDeviceLanguage();
//       const appVerifier = new RecaptchaVerifier(auth, "recaptcha-invisible", {
//         size: "invisible",
//       });
      
//       const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
//       return { verificationId: confirmationResult.verificationId, error: null };
//     } catch (error: any) {
//         const errorMessage = error instanceof Error ? error.message : "An unknown error occurred";
//         Sentry.captureException({ ...error });
//         console.error(errorMessage);
//         throw new Error(errorMessage);
//     }
// }

